import './itemDetailsToView.css';
import React from "react";
import classNames from "classnames";
import SquareImage from '../../shared/square-image/square-image';

interface Props {
    image?: string | React.ReactNode;
    description: string;
    title: string;
    onClick?: () => void;
    iconClass?: string;
    tag?: string;
    showHover?: boolean;
    size?: number;
    disableHover?: boolean;
    upperRight?: React.ReactNode;
    upperLeft?: React.ReactNode;
    className?: string;
}

const ItemDetailsToView = ({
    image,
    onClick,
    iconClass,
    tag,
    description,
    title,
    showHover,
    disableHover,
    upperLeft,
    upperRight,
    size = 130,
    className = "",
}: Props) => {

    return (
        <button className={classNames("item-details-view", className)} onClick={() => onClick?.()} style={{
            position: 'relative',
            border: 'none',
            display: 'flex',
            flexDirection: 'column',
            padding: 5,
            margin: 5,
            borderRadius: 5,
            backgroundColor: "var(--bg-card)",
            boxShadow: `0 0 5px 0 rgba(var(--color-primary-rgb), 0.8)`,
        }}>
            {tag && <span
                className="badge text-bg-info"
                style={{
                    position: 'absolute',
                    top: -2,
                    left: -2,
                    zIndex: 2,
                }}>{tag}</span>}
            <div
                className={classNames("item-details-view__over-info", showHover ? "item-details-view__over-info--hover" : "", disableHover ? "item-details-view__over-info--disable" : "")}>
                <div style={{
                    zIndex: 2,
                    color: 'white',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                }}>
                    <div style={{
                        position: 'relative',
                    }}>
                        {upperLeft && <div style={{
                            position: 'absolute',
                            height: "fit-content",
                            top: 2,
                            left: 4,
                            zIndex: 2,
                        }}>{upperLeft}</div>}
                        {upperRight && <div style={{
                            position: 'absolute',
                            height: "fit-content",
                            top: 2,
                            right: 4,
                            zIndex: 2,
                        }}>{upperRight}</div>}

                    </div>
                    <div>
                        <i className={classNames(iconClass ?? "fa-regular fa-circle-play", "fa-2xl")}></i>
                    </div>
                    <div style={{ height: "fit-content" }}>
                        {(description || title) && <>
                            <div className="item-details-view__over-title text-white" style={{
                                width: size,
                                padding: "0 5px",
                                overflow: 'hidden',
                            }}>
                                {title}
                            </div>
                            <div className='text-muted' style={{
                                fontSize: 12,
                                paddingBottom: 5,
                            }}>
                                {description}
                            </div>
                        </>}
                    </div>
                </div>
                <div className="item-details-view__over-info__shadow"></div>
            </div>
            {typeof image == 'string' ?
                <SquareImage src={image} alt={description}
                    style={{ width: size, aspectRatio: 1 / 1, objectFit: "cover" }} /> :
                <div style={{ width: size, aspectRatio: 1 / 1, objectFit: "cover" }}>
                    {image}
                </div>}
        </button>
    );
}

export default ItemDetailsToView;
